import { render, staticRenderFns } from "./CreateEditGeneCombination.vue?vue&type=template&id=0e779616&scoped=true&"
import script from "./CreateEditGeneCombination.vue?vue&type=script&lang=js&"
export * from "./CreateEditGeneCombination.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0e779616",
  null
  
)

export default component.exports